function Slide4() {
  return (
    <div className="flex flex-col w-[85vw]">
        <h1 className="text-xl text-center py-5">Questions or Concerns? <br/>Email us</h1>
        <h2 className="text-center text-blue-800 underline"><a href="mailto: accounting@mhlab.ca">Accounting</a></h2>
        <h2 className="text-center text-blue-800 underline"><a href="mailto: info@mhlab.ca">General</a></h2>
        <h2 className="text-center text-blue-800 underline"><a href="mailto: support@mhlab.ca">IT Support</a></h2>
    </div>
  )
}

export default Slide4